// extracted by mini-css-extract-plugin
export default {"container":"FM-z","modal":"GM-z","dimensions":"HM-z","brandName":"IM-z","productName":"JM-z","recipientEmail":"KM-z","recommendedFit":"LM-z","hiddenField":"MM-z"};